import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { PhoneCallIcon, XCircleIcon } from 'lucide-react';
export function Problem() {
  return <section className="py-20 bg-white" data-id="element-137">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-138">
        {/* The Hook Story */}
        <FadeIn data-id="element-139">
          <div className="bg-light-terra/30 rounded-3xl p-8 md:p-12 mb-16 relative" data-id="element-140">
            <div className="absolute -top-6 left-8 bg-terra text-white p-3 rounded-2xl shadow-lg transform -rotate-6" data-id="element-141">
              <PhoneCallIcon className="w-6 h-6" data-id="element-142" />
            </div>
            <p className="text-xl md:text-2xl font-serif text-olive leading-relaxed italic mb-6 mt-4" data-id="element-143">
              "Suena el teléfono. Son las 5:30 PM, acabas de llegar del trabajo
              y la casa es un caos. '¡Estamos a dos cuadras, pasamos a
              saludarte!'."
            </p>
            <p className="text-lg text-olive/80 leading-relaxed mb-4" data-id="element-144">
              Sientes ese nudo en el estómago, una mezcla de vergüenza y
              agotamiento. Miras los platos, los juguetes y el polvo, y solo
              quieres apagar las luces y pretender que no estás.
            </p>
            <p className="text-lg font-medium text-terra" data-id="element-145">
              No eres una "mala ama de casa". Eres una mujer con una vida real.
              El problema no eres tú, es que estás intentando seguir métodos de
              limpieza que no fueron diseñados para una mujer moderna,
              trabajadora y con familia.
            </p>
          </div>
        </FadeIn>

        {/* The Specific Problem */}
        <FadeIn delay={200} data-id="element-146">
          <div className="mb-16" data-id="element-147">
            <h2 className="text-3xl md:text-4xl font-bold text-olive mb-6 text-center" data-id="element-148">
              La trampa del fin de semana
            </h2>
            <p className="text-lg text-olive/80 leading-relaxed text-center max-w-2xl mx-auto mb-12" data-id="element-149">
              Pasas tus fines de semana "poniéndote al día" con la limpieza,
              solo para que el lunes a mediodía todo vuelva a estar igual. Te
              sientes juzgada por el desorden, especialmente cuando vienen
              visitas inesperadas. Intentas limpiar profundamente una
              habitación, te cansas a la mitad, y terminas con un desastre aún
              mayor que el inicial. Estás agotada de que tu hogar sea una lista
              de tareas pendientes que te grita cada vez que entras por la
              puerta.
            </p>
          </div>
        </FadeIn>

        {/* Why it didn't work */}
        <FadeIn delay={300} data-id="element-150">
          <div className="bg-cream rounded-3xl p-8 md:p-10 border border-sage/20" data-id="element-151">
            <h3 className="text-2xl font-bold text-olive mb-8 text-center" data-id="element-152">
              Por qué lo que has intentado no funciona:
            </h3>
            <ul className="space-y-6" data-id="element-153">
              {["El enfoque de 'todo o nada' te paraliza porque no tienes 4 horas libres para limpiar.", "Los cronogramas rígidos de 'limpieza por días' fallan en cuanto surge un imprevisto en el trabajo o con los niños.", 'Gastas dinero en 20 productos diferentes cuando solo necesitas 5 esenciales estratégicos.', 'Te enfocas en limpiar detalles invisibles mientras las superficies que todos ven siguen acumulando caos.'].map((item, index) => <li key={index} className="flex items-start" data-id="element-154">
                  <XCircleIcon className="w-6 h-6 text-terra shrink-0 mr-4 mt-1" data-id="element-155" />
                  <span className="text-lg text-olive/80 leading-relaxed" data-id="element-156">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}